<template>
	<div v-if="!loading" id="app" v-focus-boundary.circular="{id: 'app'}">
		<t-nav>

			<t-nav-item
				:to="{name: 'operational'}"
				icon="home"
				@click:inActive="setNavMenuVisible"
				@click:active="toggleNavMenu"
			/>
			<t-nav-item
				:to="{name: 'maintenance'}"
				icon="database"
				@click:inActive="setNavMenuVisible"
				@click:active="toggleNavMenu"
			/>

			<template v-slot:nav-bottom>
				<t-nav-item
					:active="showSettings"
					:showSlide="false"
					icon="settings"
					iconSize="sm"
					@click="toggleSettings"
				/>
				<t-nav-item
					:active="showLogout"
					icon="user"
					iconSize="sm"
					@click="toggleLogout"
				/>
			</template>
		</t-nav>

		<t-pane background="tint2" style="width: 100%; overflow:hidden; margin-top: 0;">
			<router-view v-if="isOffline()"/>
			<access-requirements v-else>
				<t-transition name="slide-fade" mode="out-in" appear>
					<router-view />
				</t-transition>
			</access-requirements>
		</t-pane>

		<TripTemplateDialog />
		<OrderTemplateDialog />

		<Settings :isShown="showSettings" @close="showSettings = false"/>
		<Logout :isShown="showLogout" @close="showLogout = false"/>
		<t-notification :max="5" />

	</div>
	<div v-else>
		Fallback loading screen while fetching user information
	</div>
</template>

<script>
import { mapActions as mapDriversActions } from '@/modules/drivers/store/drivers.store.js';
import { userAuth, isOffline } from '@/core';
import AccessRequirements from '@/modules/login/accessRequirements.vue';
import {
	mapState, mapGetters, mapActions
} from 'vuex';

import Settings from '@/modules/settings/Settings.vue';
import Logout from '@/modules/logout/Logout.vue';
import localeCore from '@/modules/settings/store/locale.js';
// import subMenus from './menus';

import TripTemplateDialog from '@/modules/tripTemplates/TripTemplateDialog.vue';
import OrderTemplateDialog from '@/modules/orderTemplates/OrderTemplateDialog.vue';

export default {
	name: 'App',
	components: {
		Settings,
		Logout,
		AccessRequirements,
		TripTemplateDialog,
		OrderTemplateDialog,
	},

	data() {
		return {
			showSlide: false,
			showSettings: false,
			showLogout: false,
			subMenuComponent: undefined,
			loading: null
		};
	},

	computed: {
		...mapState('login',[
			'isLoggedIn',
			'isSuper',
			'transporterCode'
		]),
		...mapGetters('login',[
			'company',
			'getUserName',
			'getUserHasAdminAccess'
		]),
	},

	watch: {
		async isLoggedIn() {
			if (this.isLoggedIn) {
				await this.fetchCompanies();
			}
		},
		async transporterCode() {
			if (this.transporterCode) {
				await this.getDrivers();
			}
		}
	},

	async created() {
		try {
			userAuth.onUserStateChanged(async(user) => {
				this.setUserInfo(user);
			});
			this.loading = false;
		} catch (err) {
			throw err;
		}
		// get locale on app creation for moment to be locale aware on inital load
		localeCore.get();
	},

	methods: {
		...mapActions([
			'setNavMenuVisible',
			'toggleNavMenu'
		]),
		...mapActions('login',[
			'fetchCompanies',
			'setUserInfo',
			'clearUserStore',
		]),
		...mapDriversActions(['getDrivers']),
		isOffline() {
			return isOffline();
		},
		logout() {
			userAuth.signOut();
			this.clearUserStore();
		},
		toggleSettings() {
			this.showSettings = !this.showSettings;
		},

		toggleLogout() {
			this.showLogout = !this.showLogout;
		}
	}
};
</script>

<style lang="scss">
@import '~@/assets/app';

body {
	margin: 0;
	padding: 0;
}

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	display: flex;
	height: 100vh;
	background: #f5f6f7;
}
</style>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
	transition: all .2s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
	transform: translateX(-10px);
}
</style>
